
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import symbolConstructorDetection from './symbol-constructor-detection.js';

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

export { useSymbolAsUid as default };
//# sourceMappingURL=use-symbol-as-uid.js.map
